import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import './Urunler.css';

const KategoriDetay = () => {
  const { kategori } = useParams();
  const navigate = useNavigate();
  const [urunler, setUrunler] = useState([]);

  useEffect(() => {
    const localVeri = localStorage.getItem('urunler');
    if (localVeri) {
      const data = JSON.parse(localVeri);
      const filtreli = data.filter(u => u.kategori === kategori);
      setUrunler(filtreli);
    }
  }, [kategori]);

  return (
    <div className="urunler-container">

      {/* 🧭 Breadcrumb */}
      <nav className="breadcrumb">
        <span onClick={() => navigate('/')}>Anasayfa</span> {'>'}
        <span onClick={() => navigate('/urunler')}>Ürünler</span> {'>'}
        <strong>{kategori}</strong>
      </nav>

      {/* 🔙 Geri Butonu */}
      <button className="geri-buton" onClick={() => navigate(-1)}>← Geri</button>

      <h1>{kategori}</h1>

      <div className="kategori-grid">
        {urunler.map((urun, i) => (
          <Link to={`/urun/${urun.id}`} key={i} className="kategori-card">
            <img src={urun.resim || '/images/bos-urun.jpg'} alt={urun.baslik} />
            <h4>{urun.baslik}</h4>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default KategoriDetay;
